import React from 'react'

import { getBrandConfig } from '../../../../../../config/brands'
import { AdvertiserLogo, type AdvertiserLogoType } from '../../../../../../shared/assets'

const DESKTOP_LOGO_WIDTH = 144
const DESKTOP_NIRION_LOGO_WIDTH: Partial<Record<AdvertiserLogoType, number>> = {
  LogoNyrion: 86,
}
const MOBILE_LOGO_SIZE = 32

const { brandConfig } = getBrandConfig()

export const MainLogo = () => (
  <>
    <AdvertiserLogo
      h="auto"
      iconName={brandConfig.logo}
      mah={40}
      size="m"
      visibleFrom="sm"
      w={DESKTOP_NIRION_LOGO_WIDTH[brandConfig.logo] || DESKTOP_LOGO_WIDTH}
    />
    <AdvertiserLogo hiddenFrom="sm" h={MOBILE_LOGO_SIZE} iconName={brandConfig.logo} size="s" w={MOBILE_LOGO_SIZE} />
  </>
)
